export const adminPaths = {
    base: "/gss-admin",
    home: "/",
    measurements: "/matningar",
    measurement: "/matningar/:name",
    indicators: "/indikatorer",
    indicator: "/indikatorer/:id",
    indicatorEdit: "/indikatorer/:id/redigera",
    indicatorCreate: "/indikatorer/skapa",
    files: "/filer",
    filesWithPath: "/filer/*",
    email: "/epost",

    getMeasurementPath(name: string): string {
        return `/matningar/${encodeURIComponent(name)}`;
    },
    getIndicatorPath(id: string): string {
        return `/indikatorer/${encodeURIComponent(id)}`;
    },
    getIndicatorEditPath(id: string): string {
        return `/indikatorer/${encodeURIComponent(id)}/redigera`;
    },
    getFilePath(path: string): string {
        return path === "" ? "/filer" : `/filer/${encodeURIComponent(path)}`;
    },
};

export const apiPaths = {
    base: "/gss-api",
    start: "/",
    summaryResults: "/summary",
    summaryResult: "/summary/:name/:period",

    getSummaryPath(name: string, period?: string): string {
        if (period != null) {
            return `${this.summaryResults}/${encodeURIComponent(name)}/${period}`;
        }
        return `${this.summaryResults}/${encodeURIComponent(name)}`;
    },
};

export const docsPaths = {
    base: "/gss-docs",
    path: "/*",
};

export const measurementsPaths = {
    base: "/gss-measurements",
    measurements: "/",
    measurement: "/:name",
    measurementEdit: "/:name/redigera",
    measurementCreate: "/skapa",

    getMeasurementPath(name: string): string {
        return `/${encodeURIComponent(name)}`;
    },
    getMeasuremenEditPath(name: string): string {
        return `/${encodeURIComponent(name)}/redigera`;
    },
    getMeasurementUrl(measurementName: string): string {
        return (
            window.location.origin +
            this.base +
            this.getMeasurementPath(measurementName)
        );
    },
};

export const mypagePaths = {
    base: "/gss-mypage",
    processes: "/",
    process: "/:measurementName/:processName/:orgId",
    timeline: "/matplan",

    getProcessPath(
        measurementName: string,
        processName: string,
        orgId: string,
    ): string {
        return `/${encodeURIComponent(measurementName)}/${encodeURIComponent(processName)}/${orgId}`;
    },
    getProcessUrl(
        measurementName: string,
        processName: string,
        orgId: string,
    ): string {
        return (
            window.location.origin +
            this.base +
            this.getProcessPath(measurementName, processName, orgId)
        );
    },
};

export const questionsPaths = {
    base: "/gss-questions",
    questionnaires: "/enkater",
    questionnaireCreate: "/enkater/skapa",
    questionnaire: "/enkater/:name/:language?",
    questions: "/fragor",
    question: "/fragor/:id",
    questionEdit: "/fragor/:id/redigera",
    questionCreate: "/fragor/skapa",
    headers: "/rubriker",
    header: "/rubriker/:id",
    headerEdit: "/rubriker/:id/redigera",
    headerCreate: "/rubriker/skapa",
    questionModules: "/moduler",
    questionModuleCreate: "/moduler/skapa",
    questionModule: "/moduler/:measurement",
    questionModuleEdit: "/moduler/:measurement/redigera",
    questionModuleCopy: "/moduler/:measurement/kopia",

    getQuestionnairePath(name: string, language?: string): string {
        if (language != null) {
            return `${this.questionnaires}/${encodeURIComponent(name)}/${language}`;
        }
        return `${this.questionnaires}/${encodeURIComponent(name)}`;
    },
    getQuestionModulePath(measurement: string): string {
        return `${this.questionModules}/${encodeURIComponent(measurement)}`;
    },
    getQuestionModuleEditPath(measurement: string): string {
        return `${this.getQuestionModulePath(measurement)}/redigera`;
    },
    getQuestionModuleCopyPath(measurement: string): string {
        return `${this.getQuestionModulePath(measurement)}/kopia`;
    },
    getQuestionPath(id: string): string {
        return `${this.questions}/${encodeURIComponent(id)}`;
    },
    getQuestionEditPath(id: string): string {
        return `${this.questions}/${encodeURIComponent(id)}/redigera`;
    },
    getHeaderPath(id: string): string {
        return `${this.headers}/${encodeURIComponent(id)}`;
    },
    getHeaderEditPath(id: string): string {
        return `${this.headers}/${encodeURIComponent(id)}/redigera`;
    },
    getQuestionnaireUrl(name: string): string {
        return (
            window.location.origin + this.base + this.getQuestionnairePath(name)
        );
    },
    getQuestionModuleUrl(measurement: string): string {
        return (
            window.location.origin +
            this.base +
            this.getQuestionModulePath(measurement)
        );
    },
};

export const resultsPaths = {
    base: "/gss-results",
    measurements: "/",
    measurement: "/:name/:period?/:tab?",
    exports: "/export",
    export: "/export/:name/:period",
    summaries: "/summary",
    summary: "/summary/:name/:period",

    getMeasurementPath(measurementName: string, period?: string): string {
        if (period != null) {
            return `/${encodeURIComponent(measurementName)}/${period}`;
        }
        return `/${encodeURIComponent(measurementName)}`;
    },
    getExportPath(name: string, period?: string): string {
        if (period != null) {
            return `${this.exports}/${encodeURIComponent(name)}/${period}`;
        }
        return `${this.exports}/${encodeURIComponent(name)}`;
    },
    getSummaryPath(name: string, period?: string): string {
        if (period != null) {
            return `${this.summaries}/${encodeURIComponent(name)}/${period}`;
        }
        return `${this.summaries}/${encodeURIComponent(name)}`;
    },
};

export const swaggerPaths = {
    base: "/gss-swagger",
    home: "/",
    path: "/:path?",
};

export const usersPaths = {
    base: "/gss-users",
    orgManagerMeasurements: "/verksamhetschefer",
    orgManagerMeasurement: "/verksamhetschefer/:name",
    readers: "/stodstrukturlasare",
    contactPersons: "/kontaktpersoner",
    administrators: "/administratorer",
    search: "/sok",
    searchEmail: "/sok/:email",

    getOrgManagerMeasurementPath(name: string): string {
        return `${this.orgManagerMeasurements}/${encodeURIComponent(name)}`;
    },
    getSearchEmailPath(email: string): string {
        return `${this.search}/${encodeURIComponent(email)}`;
    },
};
